module.exports = __webpack_public_path__ + "static/img/icon5.ed33ccc9.png";